import { sortBy, toUpper } from 'lodash'

export const formFields = [
    'ID',
    'GroupId',
    'UserName',
    'EmailId',
    'PhoneNumber',
    'IsActive',
    'Region',
    'CreatedBy',
    'CreatedOn',
    'UpdatedBy',
    'UpdatedOn'
]

// sort assets in aphabetical order
export const sortFacilityAssets = (currentScreen) => {
    const { screenColumns } = currentScreen
    const facilityIdIndex = screenColumns.findIndex(item => item.name === 'FacilityId')
    if (facilityIdIndex) {
        const facilityIdCol = screenColumns.find(item => item.name === 'FacilityId')
        if (facilityIdCol?.refLookupData?.lookupValues?.values.length) {
            const sortedColData = sortBy(facilityIdCol.refLookupData.lookupValues.values,
                [function (item) { return toUpper(item.label) }]
            )
            facilityIdCol.refLookupData.lookupValues.values = sortedColData
            screenColumns[facilityIdIndex] = facilityIdCol
            currentScreen.screenColumns = screenColumns
        }
    }
    return currentScreen
}